import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { churchesService } from '@/services/churches.service';
import { isEvaSyncRunInProgress } from '@/types';

const EVA_SYNC_RUNS_POLL_INTERVAL_MS = 10000;

export const useEvaSyncRuns = (churchId: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.EVA_SYNC_RUNS, churchId],
    queryFn: () => churchesService.getEvaSyncRuns(churchId ?? ''),
    enabled: !!churchId,
    refetchInterval: (query) => {
      const runs = query.state.data;
      if (!runs?.some((run) => isEvaSyncRunInProgress(run.status))) {
        return false;
      }
      return EVA_SYNC_RUNS_POLL_INTERVAL_MS;
    },
  });
};
